import {z} from "zod/v4";

export const inspectionStages = [
    "NOTHING",
    "PRELIM",
    "FINAL",
] as const;
export const InspectionStage = z.enum(inspectionStages);
export type InspectionStage = z.infer<typeof InspectionStage>;

export const InspectionStageOrSurcharge = z.union([InspectionStage, z.literal("SURCHARGE")]);
export type InspectionStageOrSurcharge = z.infer<typeof InspectionStageOrSurcharge>;

